import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { translations } from '../i18n/translations';

const AppContext = createContext(null);

const ROLES = ['teacher', 'principal', 'district', 'moe'];

export function AppProvider({ children }) {
  const [role, setRole] = useState('teacher');
  const [lang, setLang] = useState('en');
  const [theme, setTheme] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('shiksha-theme');
      if (saved) return saved;
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    return 'light';
  });
  const [currentSchool, setCurrentSchool] = useState(null);
  const [currentTeacher, setCurrentTeacher] = useState(null);

  // Apply theme class to <html>
  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    localStorage.setItem('shiksha-theme', theme);
  }, [theme]);

  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations['en']?.[key] || key;
  }, [lang]);

  const toggleLang = useCallback(() => {
    setLang(prev => prev === 'bn' ? 'en' : 'bn');
  }, []);

  const toggleTheme = useCallback(() => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  }, []);

  const isDark = theme === 'dark';
  const isAdmin = role === 'principal' || role === 'district' || role === 'moe';
  const isTeacher = role === 'teacher';

  return (
    <AppContext.Provider value={{
      role, setRole, ROLES,
      lang, setLang, toggleLang,
      theme, setTheme, toggleTheme, isDark,
      t, isAdmin, isTeacher,
      currentSchool, setCurrentSchool,
      currentTeacher, setCurrentTeacher
    }}>
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useApp must be used within AppProvider');
  return ctx;
}
